module.exports = __webpack_public_path__ + "static/media/incident_icon.d0dd95f8.svg";